<div class="mt-5" pAnimateOnScroll enterClass="zoomin">
  <div class="header">
    <div class="text-center">
      <div class="section-title text-center">
        {{ "FREE ATS Resume Checker" | translate }}
      </div>

      <div class="description mx-3 text-center">
        {{ "Elevate the effectiveness of your resume" | translate }}
      </div>
      <img class="arrow" src="../../../assets/img/arrow.png" />
    </div>
  </div>

  <div class="row w-100 mt-5 justify-content-center">
    <img class="col-8 col-md-4" src="../../../assets/img/ats-resume.png" />
    <div class="col-12 col-md-8 my-auto px-5 m-0">
      <div class="description-title">
        {{ "Application Tracking System" | translate }}
      </div>
      <div class="description">
        {{ "Most companies" | translate }}
      </div>

      <button routerLink="/scan-cv" class="gradient-button">
        {{ "Scan Your CV" | translate }}
      </button>
      <button class="border-button" routerLink="/soon">
        {{ "Scan Your Cover Letter" | translate }}
      </button>
    </div>
  </div>
</div>